/**
 * Singleton pour garantir une seule instance de DevanaWSClient par document
 */

import { DevanaWSClient } from "@devana/ws-tools";
import { createWordClient } from "./wordClientLib";

// Map global pour stocker les clients par apiUrl
const clientInstances = new Map<string, DevanaWSClient>();

/**
 * Récupère ou crée un client Word (singleton par apiUrl)
 */
export function getOrCreateWordClient(
  apiUrl: string,
  options?: {
    documentName?: string;
    bearerToken?: string;
    callbacks?: {
      onConnected?: (sessionId: string) => void;
      onReconnected?: (sessionId: string) => void;
      onDisconnected?: () => void;
      onError?: (error: Error) => void;
      onSessionsChanged?: () => void;
    };
  }
): DevanaWSClient {
  const key = apiUrl;

  // Si un client existe déjà et est connecté, le retourner
  const existing = clientInstances.get(key);
  if (existing && existing.isConnected()) {
    console.log("[WordClientSingleton] Reusing existing connected client");
    return existing;
  }

  // Sinon, créer un nouveau client
  console.log("[WordClientSingleton] Creating new client");
  const client = createWordClient(apiUrl, options);

  // Stocker dans la map
  clientInstances.set(key, client);

  // Nettoyer quand déconnecté
  const originalOnDisconnected = options?.callbacks?.onDisconnected;
  if (client.onDisconnected) {
    const originalCallback = client.onDisconnected;
    client.onDisconnected = () => {
      console.log(
        "[WordClientSingleton] Client disconnected, removing from cache"
      );
      clientInstances.delete(key);
      originalCallback();
      originalOnDisconnected?.();
    };
  }

  return client;
}

/**
 * Déconnecte et nettoie un client
 */
export function disconnectWordClient(apiUrl: string) {
  const key = apiUrl;
  const client = clientInstances.get(key);

  if (client) {
    console.log("[WordClientSingleton] Disconnecting and removing client");
    client.disconnect();
    clientInstances.delete(key);
  }
}

/**
 * Récupère le client existant (si connecté)
 */
export function getExistingClient(apiUrl: string): DevanaWSClient | null {
  const client = clientInstances.get(apiUrl);
  return client && client.isConnected() ? client : null;
}
